(() => {
  function init(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const buttons = [...gallery.querySelectorAll('[data-thumb]')];
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      const show = index => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.thumb) === index)));
        slides.forEach(slide => { slide.hidden = Number(slide.dataset.slide) !== index; });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => show(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight','ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          show(next); buttons[next].focus();
        });
      });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const section = select.closest('.product-section');
        const button = select.form.querySelector('.buy-button');
        if (!option || !button || !section) return;
        const submitting = select.form.dataset.submitting === 'true';
        button.disabled = submitting || option.dataset.available !== 'true';
        button.textContent = submitting ? 'Dodawanie…' : option.dataset.available !== 'true' ? 'Wyprzedane' : button.dataset.label;
        section.querySelector('[data-price]').textContent = option.dataset.price;
        [['[data-compare-price]','comparePrice'],['[data-save-badge]','saving'],['[data-discount]','discount']].forEach(([selector,key]) => {section.querySelectorAll(selector).forEach(el=>{el.textContent=option.dataset[key]||'';el.hidden=option.dataset.onSale!=='true';});});
        const variantUrl=new URL(location.href);variantUrl.searchParams.set('variant',option.value);history.replaceState({},'',variantUrl);
        const stickyPrice = section.querySelector('.sticky-buy span');
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      });
    });
    root.querySelectorAll('.sticky-buy').forEach(sticky => {
      if (sticky.dataset.ready) return;
      sticky.dataset.ready = 'true';
      const form = sticky.closest('.product-section').querySelector('.product-form');
      if (!form || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      observer.observe(form);
      sticky._observer = observer;
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.sticky-buy').forEach(el => el._observer?.disconnect());
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-slide]');
    if (slide) slide.closest('[data-gallery]').querySelector(`[data-thumb="${slide.dataset.slide}"]`)?.click();
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();

/* Native Shopify Ajax cart: same storefront session and checkout. */
(() => {
  const dialog = document.querySelector('#ReleviaCart');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const root = (document.body.dataset.shopRoot || '/').replace(/\/?$/, '/');
  const content = dialog.querySelector('[data-cart-body]');
  const error = dialog.querySelector('[data-cart-error]');
  const footer = dialog.querySelector('[data-cart-footer]');
  const status = document.querySelector('[data-cart-status]');
  const comparePrices = JSON.parse(dialog.querySelector('[data-cart-compare]')?.textContent || '{}');
  let lastFocus;
  let activeCurrency = 'PLN';
  let cartBusy = false;
  let revision = 0;
  const money = cents => new Intl.NumberFormat('pl-PL', {style: 'currency', currency: activeCurrency}).format(cents / 100);
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[ch]));
  const announce = message => { if (status) status.textContent = message; };
  async function request(path, options) {
    const response = await fetch(root + path, {headers: {Accept: 'application/json'}, ...options});
    let data;
    try { data = await response.json(); }
    catch { throw new Error('Nie udało się odczytać koszyka. Spróbuj ponownie.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'Nie udało się zaktualizować koszyka. Spróbuj ponownie.');
    return data;
  }
  function show() {
    if (!dialog.open) {
      lastFocus = document.activeElement;
      dialog.showModal();
    }
    document.documentElement.classList.add('rv-cart-open');
  }
  function setBusy(busy) {
    cartBusy = busy;
    content.setAttribute('aria-busy', String(busy));
    content.querySelectorAll('button').forEach(button => { button.disabled = busy; });
    footer.querySelectorAll('button').forEach(button => { button.disabled = busy; });
  }
  function loading() {
    error.hidden = true;
    footer.hidden = true;
    content.innerHTML = '<p class="rv-cart-loading" role="status">Ładowanie koszyka…</p>';
  }
  function cartFallback() {
    footer.hidden = true;
    content.innerHTML = `<a class="button" href="${escapeHTML(root)}cart">Otwórz stronę koszyka</a>`;
  }
  function report(err) { error.textContent = err.message; error.hidden = false; }
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('rv-cart-open');
    if (lastFocus?.isConnected) lastFocus.focus();
  });
  dialog.querySelector('[data-close-cart]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  function render(cart) {
    activeCurrency = cart.currency || 'PLN';
    error.hidden = true;
    footer.hidden = !cart.item_count;
    dialog.querySelector('[data-cart-title-count]').textContent = cart.item_count;
    dialog.querySelector('[data-cart-benefits]').hidden = !cart.item_count;
    const referenceTotal = cart.items.reduce((sum, item) => sum + Math.max(item.original_price || 0, Number(comparePrices[item.variant_id]) || 0) * item.quantity, 0);
    const savings = Math.max(0, referenceTotal - cart.total_price);
    dialog.querySelector('[data-cart-savings-row]').hidden = savings === 0;
    dialog.querySelector('[data-cart-savings]').textContent = money(savings);
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = !cart.item_count;
      el.closest('a')?.setAttribute('aria-label', `Koszyk: ${cart.item_count} produktów`);
    });
    dialog.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    if (!cart.item_count) {
      content.innerHTML = `<div class="rv-cart-empty"><h3>Twój koszyk jest pusty</h3><p>Znajdź chwilę dla siebie z Relevia.</p><a class="button" href="${escapeHTML(root)}pages/relevia-poduszka-karku">Poznaj masażer Relevia</a></div>`;
      return;
    }
    content.innerHTML = cart.items.map(item => {
      const isRelevia = item.handle === 'masazer-relevia' || String(item.url || '').split(/[?#]/)[0].endsWith('/products/masazer-relevia');
      const itemImage = isRelevia && dialog.dataset.releviaImage ? dialog.dataset.releviaImage : item.image;
      const referenceLine = Math.max(item.original_price || 0, Number(comparePrices[item.variant_id]) || 0) * item.quantity;
      return `<article class="rv-cart-item" data-cart-key="${escapeHTML(item.key)}">${itemImage ? `<a href="${escapeHTML(item.url)}"><img src="${escapeHTML(itemImage)}" width="96" height="96" alt="${escapeHTML(item.product_title)}"></a>` : ''}<div><h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a></h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHTML(item.variant_title)}</p>` : ''}<p>${referenceLine > item.final_line_price ? `<s>${money(referenceLine)}</s>` : ''}<strong>${money(item.final_line_price)}</strong></p><div class="rv-cart-quantity" aria-label="Liczba sztuk"><button type="button" data-cart-control="decrease" data-cart-quantity="${item.quantity - 1}" aria-label="Zmniejsz liczbę sztuk">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-cart-control="increase" data-cart-quantity="${item.quantity + 1}" aria-label="Zwiększ liczbę sztuk">+</button></div><button type="button" class="rv-cart-remove" data-cart-control="remove" data-cart-quantity="0" aria-label="Usuń produkt"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg></button></div></article>`;
    }).join('');
  }
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-open-cart]');
    if (!opener || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    show();
    if (cartBusy) return;
    const currentRevision = ++revision;
    loading();
    setBusy(true);
    try {
      const cart = await request('cart.js');
      if (currentRevision === revision) render(cart);
    } catch (err) {
      if (currentRevision === revision) { cartFallback(); report(err); }
    } finally {
      if (currentRevision === revision) setBusy(false);
    }
  });
  content.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-quantity]');
    if (!button || cartBusy) return;
    const key = button.closest('[data-cart-key]').dataset.cartKey;
    const control = button.dataset.cartControl;
    const quantity = Number(button.dataset.cartQuantity);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    ++revision;
    error.hidden = true;
    setBusy(true);
    try {
      render(await request('cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: key, quantity})
      }));
      announce('Koszyk został zaktualizowany.');
    } catch (err) {
      // Shopify can cap stock while rejecting a requested quantity; read the authoritative cart.
      try { render(await request('cart.js')); } catch { cartFallback(); }
      report(err);
    } finally {
      setBusy(false);
      if (dialog.open) {
        const row = [...content.querySelectorAll('[data-cart-key]')].find(item => item.dataset.cartKey === key);
        const nextFocus = row?.querySelector(`[data-cart-control="${control}"]`) || content.querySelector('[data-cart-quantity]') || dialog.querySelector('[data-close-cart]');
        nextFocus.focus();
      }
    }
  });
  // Cancel Ajax product forms before Shopify's form listener reaches the target.
  // Shopify's fetch listener then reports only the successful cart/add response.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form) return;
    event.preventDefault();
    const select = form.querySelector('[data-variant-select]');
    if (form.dataset.submitting === 'true' || select?.selectedOptions[0]?.dataset.available === 'false') return;
    const button = form.querySelector('.buy-button');
    const label = button?.dataset.label || button?.textContent;
    let formError = form.querySelector('[role=alert]');
    if (!formError) {
      formError = document.createElement('p');
      formError.setAttribute('role', 'alert');
      form.append(formError);
    }
    formError.hidden = true;
    form.dataset.submitting = 'true';
    const currentRevision = ++revision;
    setBusy(true);
    if (button) { button.disabled = true; button.textContent = 'Dodawanie…'; }
    let added = false;
    try {
      await request('cart/add.js', {method: 'POST', body: new FormData(form)});
      added = true;
      const cart = await request('cart.js');
      if (currentRevision === revision) render(cart);
      show();
      announce('Produkt został dodany do koszyka.');
    } catch (err) {
      if (added) {
        // The mutation succeeded; never invite a duplicate retry just because the read failed.
        cartFallback();
        show();
        report(new Error('Produkt został dodany do koszyka. Nie udało się odświeżyć podglądu — otwórz stronę koszyka, aby kontynuować.'));
        announce('Produkt został dodany do koszyka.');
      } else {
        formError.textContent = err.message;
        formError.hidden = false;
      }
    } finally {
      delete form.dataset.submitting;
      if (button) {
        const unavailable = select?.selectedOptions[0]?.dataset.available === 'false';
        button.disabled = unavailable;
        button.textContent = unavailable ? 'Wyprzedane' : label;
      }
      if (currentRevision === revision) setBusy(false);
    }
  }, {capture: true});
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; });
  });
  document.querySelectorAll('.mobile-menu nav a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
})();
